<script lang="ts">
    import Toast from './Toast.svelte'
    import { dismissToast, toasts } from '../store/Toasts.js'
</script>

{#if $toasts}
    <div class="" style="position: absolute; top: 0px; right: 0px; z-index: 20000;">
        {#each $toasts as toast (toast.id)}
            <Toast
                    type={toast.type}
                    dismissible={toast.dismissible}
                    on:dismiss={() => dismissToast(toast.id)}>{toast.message}</Toast>
        {/each}
    </div>
{/if}

